import React, { useContext, useState, useEffect } from 'react';
import FieldOptionsDrawerView from '../view/FieldOptionsDrawerView';
import ConditionalLogic from '../../conditional-logic/ConditionalLogic';
import FormBuilderFlagRulesEngine from '../../../components/engine/FormBuilderFlagRulesEngine';
import Settings from './FieldSettingPanelEngine';
import DescriptionLogic from '../../conditional-logic/engine/DescriptionLogicEngine';
import ScoringPanelEngine from './ScoringPanelEngine';

const getRulesForFieldId = (rules, fieldId) => {
  const matchingRules = rules.find(
    r => r.fieldId === fieldId && r.action && r.action.actionType === 'flag'
  );
  if (matchingRules && matchingRules.condition) {
    return JSON.parse(matchingRules.condition)[0];
  }
  return [];
};

const FieldOptionsDrawerEngine = props => {
  const tabs = {
    settings: {
      label: 'Settings',
      value: 'settings',
      props: {
        htmlId: props.htmlId,
        uiType: props.uiType,
        fieldOptions: props.options,
        autosaveField: props.autosaveField,
        isRequired: props.isRequired,
        isAdminOnly: props.isAdminOnly,
        isAdminOnlyOptionDisabled: props.isAdminOnlyOptionDisabled,
        isReadOnly: props.isReadOnly,
        internalId: props.internalId,
        defaultCountry: props.defaultCountry
      }
    },
    description: {
      label: 'Description',
      value: 'description',
      props: {
        formId: props.formId,
        internalId: props.internalId,
        autosaveField: props.autosaveField,
        description: props.description,
        setDescription: props.setDescription,
        rules: props.rules,
        setRules: props.setRules
      }
    },
    visibility: {
      label: 'Visibility',
      value: 'visibility',
      props: {
        selectShowHide: true,
        formId: props.formId,
        internalId: props.internalId,
        rules: props.rules,
        setRules: props.setRules,
        uiType: props.uiType,
        deletedField: props.deletedField,
        actionTypes: ['show', 'hide'],
        archived: props.archived
      }
    },
    flags: {
      label: 'Flags',
      value: 'flags',
      props: {
        preferSelf: true,
        formId: props.formId,
        internalId: props.internalId,
        rules: props.rules,
        setRules: props.setRules,
        uiType: props.uiType,
        deletedField: props.deletedField,
        actionTypes: ['flag']
      }
    },
    scoring: {
      label: 'Scoring',
      value: 'scoring',
      props: {
        fieldOptions: props.options,
        autosaveField: props.autosaveField,
        autosaveSubfield: props.autosaveSubfield
      }
    }
  };

  if (
    [
      'section_break',
      'instructional_text',
      'credas',
      'credas_out_of_scope',
      'thirdfort',
      'worldcheck',
      'worldcheck_org'
    ].indexOf(props.uiType) !== -1
  ) {
    delete tabs.flags;
  }

  if (
    ['dropdown', 'yes_no', 'credas', 'worldcheck', 'worldcheck_org'].indexOf(
      props.uiType
    ) === -1
  ) {
    delete tabs.scoring;
  }

  if (['worldcheck', 'worldcheck_org'].includes(props.uiType)) {
    tabs.scoring.label = 'Country scoring';
  }

  const getTabComponent = tabValue => {
    switch (tabValue) {
      case 'settings':
        return <Settings {...tabs.settings.props} />;
      case 'description':
        return <DescriptionLogic {...tabs.description.props} />;
      case 'visibility':
        return (
          <div>
            <ConditionalLogic {...tabs.visibility.props} />
          </div>
        );
      case 'flags':
        if (!tabs.flags) {
          return null;
        }
        return (
          <FormBuilderFlagRulesEngine
            query={getRulesForFieldId(tabs.flags.props.rules, props.internalId)}
            fieldId={props.internalId}
            rules={props.rules}
            setRules={props.setRules}
          />
        );
      case 'scoring':
        if (!tabs.scoring) {
          return null;
        }
        return <ScoringPanelEngine {...tabs.scoring.props} />;

      default:
        return null;
    }
  };

  const [tabValue, setTabValue] = useState(null);

  useEffect(() => {
    // TODO: maybe find a way to optimize this logic
    const tabKeys = Object.keys(tabs);
    const firstTab = tabs[tabKeys[0]].value;
    const tabValue =
      props.defaultTab === 'visibility' ? 'visibility' : firstTab;

    if (props.open) {
      setTabValue(tabValue);
    } else {
      setTabValue(null);
    }
  }, [props.open]);

  const onTabChnaged = (event, newValue) => {
    setTabValue(newValue);
  };

  const additionalProps = {
    tabValue,
    onTabChnaged,
    getTabComponent
  };

  return <FieldOptionsDrawerView tabs={tabs} {...props} {...additionalProps} />;
};

export default FieldOptionsDrawerEngine;
